export default "__VITE_ASSET__D9$JdVYW__"